import * as Interfaces from 'app/interfaces';
import { getAddressFromState } from 'app/utils/address';

export const serializeForm = (
  transactionId: string,
  providerId: string,
  idToken: string,
  values: Interfaces.Common.ProviderFormValues
): Interfaces.API.ProviderDetailsRequest => {
  const address = getAddressFromState(values.providerDetails.address);
  const { providerName, activityType, providerPhone, role } = values.providerDetails;

  return {
    transactionId,
    providerId,
    organisation: {
      name: providerName,
      activityType,
      phone: providerPhone,
      address
    },
    authorisedContact: {
      idamIdToken: idToken,
      role
    }
  };
};
